module.exports = __webpack_public_path__ + "img/East Timor.e2ec2394.svg";